module.exports = __webpack_public_path__ + "Floorplan_2BR.3b5f7d33.pdf";


//////////////////
// WEBPACK FOOTER
// ./client/download/Floorplan_2BR.pdf
// module id = 473
// module chunks = 0